export default "__VITE_ASSET__DibeUs0V__"